jQuery(document).ready(function($) {

    $( '.js-dropdown' ).on( 'click', function () {

        $( this ).toggleClass( 'active' );

    })

    $( '.js-dropdown .dropdown-menu li' ).on( 'click', function () {

        $( '.js-dropdown-active-title' ).html( $( this ).html() );

        let category = $(this).text();
        let currentUrl = window.location.href;
        let newUrl;

        if (currentUrl.indexOf('?') !== -1) {
            if (currentUrl.indexOf('categories=') !== -1) {
                var baseUrl = currentUrl.split('?')[0];
                var queryParams = new URLSearchParams(currentUrl.split('?')[1]);
                queryParams.delete('categories');
                queryParams.set('categories', category);
                newUrl = baseUrl + '?' + queryParams.toString();
            } else {
                newUrl = currentUrl + '&categories=' + encodeURIComponent(category);
            }
        } else {
            newUrl = currentUrl + '?categories=' + encodeURIComponent(category);
        }

        window.location.href = newUrl;

    })

})